import React, { Component } from 'react';
import { facultyData } from '../facultyData';
interface AcademicTemplateProps {
  data: typeof facultyData;
  showQR: boolean;
  showPageNumbers: boolean;
}
export function AcademicTemplate({
  data,
  showQR,
  showPageNumbers
}: AcademicTemplateProps) {
  return <div className="font-serif-cv text-slate-900 leading-relaxed" data-id="element-51">
      {/* Header */}
      <div className="border-b-2 border-navy pb-6 mb-8 flex justify-between items-start" data-id="element-52">
        <div data-id="element-53">
          <h1 className="text-4xl font-bold text-navy mb-2" data-id="element-54">
            {data.personalInfo.fullName}
          </h1>
          <p className="text-xl text-slate-700 font-medium" data-id="element-55">
            {data.personalInfo.designation}
          </p>
          <p className="text-lg text-slate-600" data-id="element-56">
            {data.personalInfo.department}
          </p>
        </div>
        <div className="text-right text-sm text-slate-600 space-y-1" data-id="element-57">
          <p data-id="element-58">{data.personalInfo.email}</p>
          <p data-id="element-59">{data.personalInfo.phone}</p>
          <p className="max-w-[200px]" data-id="element-60">{data.personalInfo.officeAddress}</p>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-8" data-id="element-61">
        {/* Left Column - Meta */}
        <div className="col-span-4 space-y-8" data-id="element-62">
          <section data-id="element-63">
            <h2 className="text-lg font-bold text-navy uppercase tracking-wider mb-3 border-b border-slate-200 pb-1" data-id="element-64">
              Research Interests
            </h2>
            <ul className="list-disc list-inside text-sm space-y-1 text-slate-700" data-id="element-65">
              {data.researchInterests.map((interest, i) => <li key={i} data-id="element-66">{interest}</li>)}
            </ul>
          </section>

          <section data-id="element-67">
            <h2 className="text-lg font-bold text-navy uppercase tracking-wider mb-3 border-b border-slate-200 pb-1" data-id="element-68">
              Skills
            </h2>
            <div className="space-y-3" data-id="element-69">
              {data.skills.map((skillGroup, i) => <div key={i} data-id="element-70">
                  <h3 className="text-sm font-bold text-slate-800 mb-1" data-id="element-71">
                    {skillGroup.category}
                  </h3>
                  <p className="text-sm text-slate-600" data-id="element-72">
                    {skillGroup.items.join(', ')}
                  </p>
                </div>)}
            </div>
          </section>

          <section data-id="element-73">
            <h2 className="text-lg font-bold text-navy uppercase tracking-wider mb-3 border-b border-slate-200 pb-1" data-id="element-74">
              Memberships
            </h2>
            <div className="space-y-3" data-id="element-75">
              {data.memberships.map((membership, i) => <div key={i} className="text-sm" data-id="element-76">
                  <div className="font-bold text-slate-800" data-id="element-77">
                    {membership.organization}
                  </div>
                  <div className="text-slate-600" data-id="element-78">
                    {membership.role} (Since {membership.since})
                  </div>
                </div>)}
            </div>
          </section>
        </div>

        {/* Right Column - Main */}
        <div className="col-span-8 space-y-8" data-id="element-79">
          <section data-id="element-80">
            <h2 className="text-xl font-bold text-navy uppercase tracking-wider mb-4 border-b border-slate-200 pb-1" data-id="element-81">
              Education
            </h2>
            <div className="space-y-4" data-id="element-82">
              {data.education.map((edu, i) => <div key={i} data-id="element-83">
                  <div className="flex justify-between items-baseline" data-id="element-84">
                    <h3 className="font-bold text-slate-900" data-id="element-85">{edu.degree}</h3>
                    <span className="text-sm font-bold text-slate-600" data-id="element-86">
                      {edu.year}
                    </span>
                  </div>
                  <div className="italic text-slate-700" data-id="element-87">{edu.institution}</div>
                  {edu.details && <div className="text-sm text-slate-600 mt-1" data-id="element-88">
                      {edu.details}
                    </div>}
                </div>)}
            </div>
          </section>

          <section data-id="element-89">
            <h2 className="text-xl font-bold text-navy uppercase tracking-wider mb-4 border-b border-slate-200 pb-1" data-id="element-90">
              Professional Experience
            </h2>
            <div className="space-y-4" data-id="element-91">
              {data.experience.map((exp, i) => <div key={i} data-id="element-92">
                  <div className="flex justify-between items-baseline" data-id="element-93">
                    <h3 className="font-bold text-slate-900" data-id="element-94">{exp.role}</h3>
                    <span className="text-sm font-bold text-slate-600" data-id="element-95">
                      {exp.period}
                    </span>
                  </div>
                  <div className="italic text-slate-700" data-id="element-96">
                    {exp.organization}
                  </div>
                  <div className="text-sm text-slate-600 mt-1" data-id="element-97">
                    {exp.description}
                  </div>
                </div>)}
            </div>
          </section>

          <section data-id="element-98">
            <h2 className="text-xl font-bold text-navy uppercase tracking-wider mb-4 border-b border-slate-200 pb-1" data-id="element-99">
              Selected Publications
            </h2>
            <div className="space-y-3" data-id="element-100">
              {data.publications.slice(0, 5).map((pub, i) => <div key={i} className="text-sm pl-4 relative" data-id="element-101">
                  <span className="absolute left-0 top-0" data-id="element-102">•</span>
                  <span className="font-medium" data-id="element-103">{pub.authors}</span> ({pub.year}
                  ). "{pub.title}". <span className="italic" data-id="element-104">{pub.venue}</span>.
                </div>)}
            </div>
          </section>

          <section data-id="element-105">
            <h2 className="text-xl font-bold text-navy uppercase tracking-wider mb-4 border-b border-slate-200 pb-1" data-id="element-106">
              Awards & Honors
            </h2>
            <div className="space-y-2" data-id="element-107">
              {data.awards.map((award, i) => <div key={i} className="flex justify-between text-sm" data-id="element-108">
                  <div data-id="element-109">
                    <span className="font-bold" data-id="element-110">{award.title}</span>,{' '}
                    {award.issuer}
                  </div>
                  <span className="text-slate-600" data-id="element-111">{award.year}</span>
                </div>)}
            </div>
          </section>
        </div>
      </div>

      {/* Footer Elements */}
      {showQR && <div className="absolute bottom-12 right-12" data-id="element-112">
          <img src={`https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${encodeURIComponent(data.personalInfo.profileUrl)}&color=1C4370&bgcolor=ffffff`} alt="Profile QR" className="w-20 h-20" data-id="element-113" />
        </div>}

      {showPageNumbers && <div className="absolute bottom-8 left-0 right-0 text-center text-xs text-slate-400 font-sans" data-id="element-114">
          Page 1 of 2
        </div>}
    </div>;
}